import { Text } from "@mantine/core"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { ActionIcon } from "@tfg/ui"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { DateCell } from "~/components/cells/DateCell"

import { useDeleteMagicLinkMutation } from "./hooks"

const columnHelper = createColumnHelper<AdminResponses.MagicLinkLogs>()
export const useMagicLinkColumns =
  (): ColumnDef<AdminResponses.MagicLinkLogs>[] => {
    const { mutate: deleteMagicLink } = useDeleteMagicLinkMutation()

    return useMemo<ColumnDef<AdminResponses.MagicLinkLogs, any>[]>(
      () => [
        columnHelper.accessor("id", {
          header: "ID",
          enableSorting: false,
          cell: (info) => <Text>{info.getValue()}</Text>,
        }),
        columnHelper.accessor("user.email", {
          header: "User Email",
          enableSorting: false,
          cell: (info) => <Text>{info.getValue()}</Text>,
        }),
        columnHelper.accessor("type", {
          header: "Type",
          enableSorting: false,
          cell: (info) => <Text>{info.getValue()}</Text>,
        }),
        columnHelper.accessor("createdAt", {
          header: "createdAt",
          cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        }),
        columnHelper.accessor("updatedAt", {
          header: "updatedAt",
          cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        }),
        columnHelper.accessor("deletedAt", {
          header: "Deleted",
          enableSorting: false,
          cell: ({ row, getValue }) => {
            const deletedAt = getValue()
            if (deletedAt) return <Text>TRUE</Text>
            return (
              <ActionIcon
                type="delete"
                onClick={() => deleteMagicLink(row.original.id)}
              />
            )
          },
        }),
      ],
      [deleteMagicLink]
    )
  }
